mutation TravelAuthorizationEntryStampProcessing(
  $input: TravelAuthorizationEntryStampProcessingInput!
) {
  travelAuthorizationEntryStampProcessing(input: $input) {
    processRequests {
      message
      isWarning
      isSuccess
      isFail
      id
      rowTimestamp
      reference
    }
  }
}
